import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Dispatch } from "react";
import { Microservices } from "../../../app/AllowedMicroservices";
import { RootState } from "../../../app/store";
import apiActionCreator, {
  HttpMethods,
} from "../../../services/apiActionCreator";
import { FetchStatus } from "../../common/enums";
import { DataState, IReportValue, sortReportValue } from "../common";

const initialState: DataState = {
  data: [],
  status: FetchStatus.Idle,
};

export const dataSlice = createSlice({
  name: "userEnabledVsDisabledByGroup",
  initialState,
  reducers: {
    fetching: (state) => {
      state.status = FetchStatus.Fetching;
    },
    fetched: (state, action: PayloadAction<IReportValue[]>) => {
      state.data = action.payload;
      state.data.sort(sortReportValue);
      state.status = FetchStatus.Fetched;
    },
    error: (state) => {
      state.data = [];
      state.status = FetchStatus.Error;
    },
  },
});

export const { fetching, fetched, error } = dataSlice.actions;

export const fetchUsersEnabledVsDisabledByGroup = (companyId: string) => (
  dispatch: Dispatch<object>
) => {
  let endpoint = `/user/reports/enabledVsDisabledbyGroup/${companyId}`;
  return dispatch(
    apiActionCreator({
      endpoint,
      types: {
        requestType: fetching,
        successTypes: [
          {
            actionOrCreator: fetched,
          },
        ],
        errorTypes: [
          {
            actionOrCreator: error,
          },
        ],
      },
      method: HttpMethods.GET,
      microservice: Microservices.COMPANY_SERVICE,
      authenticated: true,
    })
  );
};

export const selectUserEnabledVsDisabledByGroupData = (state: RootState) =>
  state.reports.user.userEnabledVsDisabledByGroup.data;
export const selectUserEnabledVsDisabledByGroupIsFetching = (
  state: RootState
) =>
  state.reports.user.userEnabledVsDisabledByGroup.status ===
  FetchStatus.Fetching;

export default dataSlice.reducer;
